import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import styled from "styled-components";

const WrapperStyled = styled.div`
  padding: 10px;
  height: 700px;
  overflow-y: auto;
`;

const ProductStyled = styled.div`
  width: 100px;
  height: 100px;
  margin-bottom: 5px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ProductsStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 5px;
`;

export default function ProductChooseDialog(props) {
    const {open, onClose, products, onChooseProduct} = props;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <WrapperStyled>
                <ProductsStyled>
                    {products.map(product => {
                        return (
                            <ProductStyled
                                onClick={() => {
                                    onChooseProduct(product);
                                }}
                                key={product._id}>
                                <img src={product.imageUrl} alt="product image url"/>
                            </ProductStyled>
                        );
                    })}
                </ProductsStyled>
            </WrapperStyled>
        </Dialog>);
}